module.exports = __webpack_public_path__ + "1643b562722d8ae17ba11aa7fc328c09.png";